<template>
  <GlobalView>
    <div class="authorized-parent">
      <LsNavbar />
      <RouterView />
    </div>
  </GlobalView>
</template>

<script>
import LsNavbar from '@/components/LsNavbar/LsNavbar.vue';
import { TOSModal } from '@/modals';
import { TERMS_OF_SERVICE__MUTATE_HAS_AGREED } from '@/store/types';
import { lsModalService } from 'ls-vue-common';
import { mapMutations, mapState } from 'vuex';
import GlobalView from './GlobalView/GlobalView.vue';

export default {
  name: 'AuthorizedParentView',
  components: {
    LsNavbar,
    GlobalView,
  },
  computed: {
    ...mapState(['auth']),
  },
  created() {
    const { has_user_agreed_to_current_tos } = this.auth.user;

    this[TERMS_OF_SERVICE__MUTATE_HAS_AGREED](has_user_agreed_to_current_tos);

    if (!has_user_agreed_to_current_tos && !this.auth.customer.policies_accepted_at) {
      lsModalService.open({
        parent: this,
        component: TOSModal,
        cancelable: false,
        width: 620,
      });
    }
  },
  methods: {
    ...mapMutations([TERMS_OF_SERVICE__MUTATE_HAS_AGREED]),
  },
};
</script>

<style lang="scss" scoped>
.authorized-parent {
  margin-bottom: 30px;
}
</style>
